<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          isEditFacility
            ? $t("settings.facility.updateFacility")
            : $t("settings.facility.newFacility")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <v-row align="center">
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.en')})`"
                  color="secondary"
                  type="text"
                  v-model="facilityModelObj.nameEn"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.en") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.ar')})`"
                  color="secondary"
                  type="text"
                  v-model="facilityModelObj.nameAr"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.ar") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-row>
                <v-col>
                  <p class="gray1--text mb-1">
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.facility.facilityImage") }}
                  </p>
                  <croppa
                    class="ml-2 mt-2"
                    v-model="myCroppa"
                    :width="200"
                    :height="200"
                    :placeholder="'Choose an image'"
                    :placeholder-font-size="16"
                    :accept="'image/png'"
                    :file-size-limit="0"
                    :quality="1"
                    :zoom-speed="3"
                    :disabled="false"
                    :disable-drag-and-drop="false"
                    :disable-click-to-choose="false"
                    :disable-drag-to-move="false"
                    :disable-scroll-to-zoom="false"
                    :disable-rotation="false"
                    :prevent-white-space="false"
                    :reverse-scroll-to-zoom="false"
                    :show-remove-button="true"
                    :remove-button-color="'red'"
                    :remove-button-size="10"
                  >
                    <img
                      v-if="isEditFacility"
                      slot="initial"
                      :src="
                        `${$store.getters.imageBaseUrl}/${facilityModelObj.avatar}`
                      "
                    />
                  </croppa>
                </v-col>
                <!-- <v-col>
                  <avatar
                    class="my-6"
                    v-if="facilityModelObj.avatar"
                    :size="100"
                    :src="`${
                      $store.getters.imageBaseUrl
                      }/${
                        facilityModelObj.avatar
                      }`"
                  />
                </v-col> -->
              </v-row>
            </v-col>
            <v-col cols="9" sm="9" md="9" class="py-0 mx-auto">
              <!-- <div class="d-flex justify-space-around"> -->
              <!-- <v-btn class="custom-button text-none" @click="onCancel">
                  {{ $t("common.cancel") }}
                </v-btn> -->
              <v-btn
                :disabled="!isAllEntriesEntered"
                class="white--text rounded-lg"
                color="primary"
                type="submit"
                width="100%"
                :loading="btnLoading"
              >
                {{ isEditFacility ? $t("common.update") : $t("common.save") }}
              </v-btn>
              <!-- </div> -->
            </v-col>
            <v-col v-if="isError != null" cols="12" sm="12"
              ><Alert :message="isError" />
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { createFacility } from "../../methods/facility/create_facility";
import { updateFacility } from "../../methods/facility/update_facility";
// import imageUploader from "vue-image-upload-resize";
// import Avatar from "vue-avatar";
export default {
  data() {
    return {
      hasLogo: false,
      myCroppa: {},
      btnLoading: false,
      facilityModelObj: {
        nameAr: "",
        nameEn: "",
        avatar: null
      },
      isError: null,
      reRender: 0
    };
  },
  components: {
    // imageUploader,
    // Avatar,
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditFacility) {
      this.facilityModelObj = this.$format.cloneVariable(this.editFacility);
    }
  },
  watch: {
    isEditFacility: {
      handler() {
        this.myCroppa.refresh();
        if (this.isEditFacility) {
          this.facilityModelObj = this.$format.cloneVariable(this.editFacility);
        } else {
          this.facilityModelObj = {
            nameAr: "",
            nameEn: "",
            avatar: null
          };
          this.hasLogo = false;
          this.reRender++;
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["isEditFacility", "editFacility", "appSettingFormName"]),
    isAllEntriesEntered() {
      return (
        this.myCroppa.img &&
        this.facilityModelObj.nameEn &&
        this.facilityModelObj.nameAr
      );
    }
  },
  methods: {
    async onSave() {
      this.btnLoading = true;
      const input = {
        input: this.$format.cloneVariable(this.facilityModelObj)
      };
      if (!this.isEditFacility) {
        if (this.myCroppa.hasImage()) {
          let blob = await this.myCroppa.promisedBlob();
          input.input.avatar = blob;
        }
        createFacility(input).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchFacility");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
            this.facilityModelObj = {};
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      } else {
        const updateInput = {
          id: input.input._id,
          input: {
            nameEn: input.input.nameEn,
            nameAr: input.input.nameAr
          }
        };
        if (this.myCroppa.hasImage()) {
          const file = this.myCroppa.getChosenFile();
          if (file) {
            updateInput.input.avatar = file;
          }
        }
        updateFacility(updateInput).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchFacility");
            this.reRender++;
            this.$store.commit("IS_EDIT_FACILITY", false);
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      }
    },
    setLogo(output) {
      console.log(this.$refs.imageUpload);
      this.hasLogo = true;
      this.facilityModelObj.avatar = output;
    }
    // onCancel() {
    //   this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
    //   this.$store.commit("IS_EDIT_FACILITY", false);
    // },
  }
};
</script>
